import { useMemo } from "react";
import { Link } from "react-router-dom";
import { FlagRegionByIso } from "components/Function";

const useColumnTableVideos = (heightRow = 100, setPreview) => {
    const columns = useMemo(() => {
        return [
            {
                field: "_id",
                headerName: "",
                sortable: false,
                editable: false,
                cellClass: "centered-cell",
                width: 10,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            },
            {
                field: "video_id",
                headerName: "Video",
                sortable: false,
                editable: false,
                autoHeight: true,
                cellClass: "overflow-visible",
                width: 500,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <div className="d-flex justify-content-center align-items-center me-3 h-100">
                            <div className="spy-video-preview" onClick={() => setPreview(row.share_url)}>
                                <img
                                    className="al-border-radius-8"
                                    width={60}
                                    height={60}
                                    alt="video_preview"
                                    src={row.cover_url}
                                />
                                <div className="position-absolute top-0 start-0 w-100 h-100 justify-content-center align-items-center backdrop">
                                    <i className="ki-duotone ki-to-right fs-3x"></i>
                                </div>
                            </div>
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2 "
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-html={`<div style="width: 200px">${row.video_title}</div>`}
                                className="mb-0 fw-bold"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                {row.video_title}
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.region?.key ? <FlagRegionByIso name={row.region.name} iso={row.region.key} /> : ""}
                                {Boolean(row.is_email) && (
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Email"}
                                        className="fa fa-envelope-o fs-3"
                                    ></i>
                                )}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                field: "influencer",
                headerName: "Creator",
                cellClass: "centered-cell",
                sortable: false,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <div className="symbol symbol-45px symbol-circle">
                            <img
                                src={row.influencer.avatar_url}
                                alt=""
                                className="me-3"
                                style={{ width: 20, height: 20, objectFit: "cover" }}
                            />
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2 w-100px"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                className="mb-0 fw-bold"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                {row.influencer.unique_id}
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.influencer.region?.key ? (
                                    <FlagRegionByIso
                                        name={row.influencer.region.name}
                                        iso={row.influencer.region.key}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <span
                                className="mb-0 text-gray-500"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                Followers: {row.influencer.follower_count}
                            </span>
                        </div>
                    </div>
                ),
            },
            {
                field: "digg_count",
                headerName: "Likes",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "comment_count",
                headerName: "Comments",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "share_count",
                headerName: "Shares",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "engagement_rate",
                headerName: "ER Rate",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "sales",
                headerName: "Estimated Sales",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "publish_time",
                headerName: "Publish Time",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "-",
                headerName: "Actions",
                editable: false,
                cellClass: "centered-cell",
                width: 140,
                // pinned: "right",
                cellRenderer: ({ data: row }) => (
                    <>
                        <Link
                            role="button"
                            to={`/admin/spy-advanced/videos/${row.video_id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                            data-tooltip-id="my-tooltip"
                        >
                            <i className="fa fa-search fs-2"></i>
                        </Link>
                    </>
                ),
            },
        ];
    }, [heightRow, setPreview]);

    return columns;
};

export default useColumnTableVideos;
